import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import downArrow from "../../assets/images/navbar-icons/downArrow-menu.svg";
import upArrow from "../../assets/images/navbar-icons/upArrow-menu.svg";
import {FlagIcon} from "../FlagIcon";
import styles from "./LanguageOptions.module.css";

const lngs = {
  en: {nativeName: "En", flagCode: "gb"},
  af: {nativeName: "Af", flagCode: "za"},
};

const dropdownStyle = {
  position: "absolute",
  top: "110%",
  left: "-15px",
  right: 0,
  minWidth: "175px",
  height: 72,
  background: "linear-gradient(0deg, #383844, #383844), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
  borderBottomRightRadius: 12,
  borderBottomLeftRadius: 12,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  display: "flex",
  flexDirection: "row",
  gap: "10px",

  zIndex: 100,
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  opacity: 1,
  alignItems: "center",
  justifyContent: "center",
};

const langBtnStyle = {
  width: 35,
  height: 30,
  fontWeight: 600,
  fontSize: 16,
  border: "none",
  cursor: "pointer",
  padding: "5px 8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: 1,
  transition: "background 0.3s",
  gap: "10px",
};

const selectStyle = {
  position: "relative",
  background: "transparent",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  color: "var(--text-primary)",
  fontSize: 13,
  userSelect: "none",
  marginLeft: "auto", // Ensures right alignment in flex parent
};

const arrowStyle = {
  width: 14,
  height: 14,
  paddingRight: 15,
};

const LanguageOption = () => {
  const {i18n} = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(i18n.language.slice(0, 2) in lngs ? i18n.language.slice(0, 2) : "en");
  const ref = useRef();

  const {t} = useTranslation();

  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = lng => {
    setSelected(lng);
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  return (
    <div
      style={selectStyle}
      ref={ref}
      onClick={() => setOpen(o => !o)}
    >
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          width: "100%",
          background: "transparent",
          fontFamily: "inherit",
          fontSize: "inherit",
          color: "inherit",
          boxShadow: "none",
        }}
      >
        <FlagIcon
          code={lngs[selected]?.flagCode}
          size={16}
        />
        <span
          className={styles.language_title}
          style={{
            flex: 1,
            textAlign: "left",
            background: "transparent",
            fontFamily: "inherit",
            fontSize: "inherit",
          }}
        >
          {t("language")}
        </span>
        <img
          src={open ? upArrow : downArrow}
          alt="arrow"
          style={arrowStyle}
        />
      </span>
      {open && (
        <div style={dropdownStyle}>
          {Object.keys(lngs).map(lng => (
            <button
              key={lng}
              type="button"
              style={{
                ...langBtnStyle,
                opacity: 1,
                fontFamily: "inherit",
                fontSize: "inherit",
              }}
              className={selected === lng ? `${styles.language_btn_bg} ${styles.selected}` : styles.language_btn_bg}
              onClick={e => {
                e.stopPropagation();
                handleSelect(lng);
              }}
            >
              <FlagIcon
                code={lngs[lng].flagCode}
                size={22}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageOption;
